<!-- 最后审核人下拉组件 -->
<template>
  <el-select
    size="small"
    clearable
    filterable
    remote
    :remote-method="remoteMethod"
    placeholder="请选择"
    :value="curValue"
    @visible-change="visibleChange"
    @change="handleInput"
  >
    <div class="d-f justify-b f-s-12 p-lr-10 p-tb-5 bg-ecf5ff">
      <span>审核人</span>
      <span class="c-p" @click="sortList">
        句子数
        <i class="el-icon-sort"></i>
      </span>
    </div>
    <el-option
      class="f-s-12 d-f justify-b"
      v-for="item in options"
      :key="item.trId"
      :label="item.name"
      :value="item.name"
    >
      <span class="p-lr-10">{{ item.name }}</span>
      <span class="p-lr-10 w-60 t-r">{{ item.sentNum }}</span>
    </el-option>
  </el-select>
</template>

<script>
import Vue from 'vue';
import { queryQcTrStat } from '@/api/dot/qc';
export default {
  name: 'SelectNameList',
  props: ['value', 'orderId', 'qcTaskId', 'qcStatus'],
  data: () => {
    return {
      curValue: [],
      options: [],
      isDesc: true,
    };
  },
  watch: {
    value(n) {
      this.curValue = n;
    },
  },
  mounted() {
    this.getNameList('');
  },
  methods: {
    // 搜索
    remoteMethod(val) {
      if (val !== '') {
        this.getNameList(val);
      }
    },

    // 获取最后审核人列表
    getNameList(name) {
      queryQcTrStat({
        orderId: this.orderId,
        qcTaskId: this.qcTaskId,
        orderWay: 'desc',
        size: 20,
        qcStatus: this.qcStatus,
        name: name,
      }).then((res) => {
        this.options = res.data?.data;
      });
    },

    // 排序
    sortList() {
      this.isDesc = !this.isDesc;
      if (this.isDesc) {
        this.options.sort((a, b) => {
          return b.sentNum - a.sentNum;
        });
      } else {
        this.options.sort((a, b) => {
          return a.sentNum - b.sentNum;
        });
      }
    },

    // 点击下拉触发事件
    visibleChange(val) {
      if (val) {
        this.getNameList();
      }
    },

    handleInput(val) {
      this.$emit('input', val);
    },
  },
};
</script>
